"use client";

import React, { useCallback, useState } from "react";
import { AccountMenu } from "@/components/account/AccountMenu.js";
import { AccountIcon } from "@rosette/web_components/src/icon/AccountIcon.js";
import { useUserOrIncompleteUser } from "@/components/env/EnvContext.js";
import Link from "next/link";
import { PopupButton } from "@/components/generic/popup/PopupButton.js";
import { cn } from "@rosette/ts/src/util/cn.js";
import { usePathname } from "next/navigation";
import { Path } from "@rosette/ts/src/util/Path.js";
import { LoginFormModal } from "@/components/auth/LoginForm.js";


const BUTTON = cn(
    "flex cursor-pointer flex-row items-center gap-1 p-[0.4em] text-xl",
    "text-body hover:text-strong active:text-body",
);
const ICON = "size-[1.25em] max-w-none fill-current";


interface AccountMenuProps {
    className?: string;
}


export function AccountMenuButton({ className }: AccountMenuProps) {
    const { incompleteUser, user } = useUserOrIncompleteUser();
    const pathname = usePathname();

    const [showLogin, setShowLogin] = useState(false);
    const closeModal = useCallback(() => setShowLogin(false), [setShowLogin]);

    if (incompleteUser) {
        return (
            <Link
                className={cn(
                    BUTTON,
                    className ?? null,
                )}
                href="/setup">

                <span>
                    Set Up
                </span>
                <AccountIcon className={ICON} />
            </Link>
        );
    }
    if (!user) {
        return (
            <>
                <Link
                    className={cn(
                        BUTTON,
                        className ?? null,
                    )}
                    href={new Path("/login", { redirect: pathname }).toString()}
                    onClick={(event) => {
                        if (!showLogin) {
                            event.preventDefault();
                            setShowLogin(true);
                        }
                    }}>

                    <span>
                        Sign In
                    </span>
                    <AccountIcon className={ICON} />
                </Link>

                <LoginFormModal
                    visible={showLogin}
                    close={closeModal} />
            </>
        );
    }

    return (
        <PopupButton
            buttonClassName={cn(BUTTON, className ?? null)}
            contentClassName="min-w-[240px] overflow-hidden rounded-2xl bg-surface-sunken p-0"
            darkMode={true}
            minPopupWidthPx={240}
            buttonContent={(
                <>
                    <span>
                        {user.displayName}
                    </span>
                    <AccountIcon className={ICON} />

                    <span className="sr-only">
                        Open Account Menu
                    </span>
                </>
            )}>

            <AccountMenu user={user} />
        </PopupButton>
    );
}
